export default __webpack_public_path__ + "static/media/Water_utility_W.431745ea.png";